export const MENSAJE_SENAS_BLOQUEADAS =
  "Para cobrar señas necesitás tener tus cobros validados en ZOCO Pagos.";

// Solo se bloquea cuando el backend informa explícitamente que la cuenta no puede
// cobrar. Sin capability (error de red, cuenta vieja) se deja pasar y decide el backend.
export function puedeCobrarSenas(me) {
  const capability = me?.capability;
  if (!capability) return true;
  return Boolean(capability.canSellPaidTickets);
}

// Una cuenta sin cobros validados guarda siempre el bar gratis: el backend evalúa el
// estado final, así que una seña que quedó de antes tiene que viajar en cero.
export function sinSenasEnBar(barForm) {
  return {
    ...barForm,
    reservationMode: "free",
    depositAmount: 0,
    zonePricingEnabled: false,
  };
}
